import React from "react";
import { Link } from "react-router-dom";
import allActions from "../actions/allActions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../reducers/combineReducer";
import { Toggle } from "../components/utils/Toggle";
import { FormattedMessage } from "react-intl";
import { VscAccount, VscSignOut } from "react-icons/vsc";

export const Navbar: React.FC = () => {
  const navHeaderClass =
    "lg:mt-0 text-blue-200 hover:text-yellow-300 mr-4 mt-4 right-0";
  const navTextClass = "lg:mt-0 text-white hover:text-blue-300 mr-4 mt-4";
  const iconNavClass = "text-white hover:text-blue-300 ml-2";
  const bottomOfNavigation = "flex flex-col mb-5";
  const eventToggle = "EVENTS_TOGGLE";
  const leadToggle = "LEAD_TOGGLE";
  const certToggle = "CERT_TOGGLE";
  const navToggle = "NAVBAR_TOGGLE";
  const toggleState = useSelector((state: RootState) => state["toggleState"]);
  const iconClassName = toggleState[navToggle]
    ? "fas fa-chevron-left fa-xs shadow-md"
    : "fas fa-chevron-right fa-xs shadow-md";
  const dispatch = useDispatch();

  const toggleElement = (id: string) => {
    if (toggleState[id]) {
      dispatch(allActions.toggleActions.hideToggle(id));
    } else {
      dispatch(allActions.toggleActions.showToggle(id));
    }
  };

  const logOut = () => {
    sessionStorage.clear();
    dispatch(allActions.loginActions.logout());
  };

  return (
    <div className='flex flex-row'>
      {toggleState[navToggle] ? (
        <nav className='bg-brand-dark_blue pr-6 pt-2 pl-3 h-screen flex flex-col shadow-r justify-between items-center'>
          <div className='flex flex-col'>
            <Link to='/'>
              <span className={navTextClass}>
                <FormattedMessage id='Navigation.Main' />
              </span>
            </Link>
            <span className={navHeaderClass}>
              <button onClick={() => toggleElement(eventToggle)}>
                <FormattedMessage id='Navigation.Event_Header' />
              </button>
            </span>
            <Toggle id={eventToggle}>
              <Link to='/events'>
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.ListEvents' />
                </span>
              </Link>
              <Link to='/createevent'>
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.CreateEvent' />
                </span>
              </Link>
            </Toggle>
            <span className={navHeaderClass}>
              <button onClick={() => toggleElement(leadToggle)}>
                <FormattedMessage id='Navigation.Lead_Header' />
              </button>
            </span>
            <Toggle id={leadToggle}>
              <Link to='/feedback'>
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.Lead_Feedback' />
                </span>
              </Link>
              <Link to='/marketing'>
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.Lead_Marketing' />
                </span>
              </Link>
            </Toggle>
            <span className={navHeaderClass}>
              <button onClick={() => toggleElement(certToggle)}>
                <FormattedMessage id='Navigation.Cert_Header' />
              </button>
            </span>
            <Toggle id={certToggle}>
              <Link to='/createcert'>
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.Cert_New' />
                </span>
              </Link>
              <Link to='/certs'>
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.Cert_All' />
                </span>
              </Link>
            </Toggle>
          </div>
          <div className={bottomOfNavigation}>
            <div className='w-full h-full'>
              <Link to='/account'>
                <VscAccount size={32} className={`${iconNavClass}`} />
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.Account' />
                </span>
              </Link>
            </div>
            <div className='w-full h-full'>
              <button onClick={logOut}>
                <VscSignOut size={32} className={`${iconNavClass}`} />
                <span className={navTextClass}>
                  <FormattedMessage id='Navigation.Logout' />
                </span>
              </button>
            </div>
          </div>
        </nav>
      ) : (
        <nav className='bg-brand-dark_blue pr-6 h-screen flex flex-col shadow-r'></nav>
      )}
      <div>
        <button onClick={() => toggleElement(navToggle)}>
          <i className={iconClassName}></i>
        </button>
      </div>
    </div>
  );
};

export default Navbar;
